//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      status: 'locating',
      loading: true,
      menu: []
    }
  },
  async mounted() {

    let currentLocale = window.localStorage.getItem('app_lang');
    if(currentLocale) {
      this.$i18n.setLocale(currentLocale);
      this.$root.$emit('update_lang');
    }

    this.$store.commit('auth/storeAccessToken',  null)


    const { location_success_at } = await this.$CapacitorStorage.get({ key: 'location_success_at' })
    if (location_success_at) {
      //luxon.DateTime.now().valueOf()
      if (luxon.DateTime.now().minus({ hours: 1 }).valueOf() > location_success_at) {
        //return;
      }
    }

    try {
      let device = await this.$CapacitorDevice.getInfo()
      if(this.system == 'app') {
        this.visible = true
        this.$root.$emit('splash_hide')
        if (_.get(device, 'platform') == 'android') {
          this.checkRestriction()
        } else {
          this.checkLocation()
        }
      }
    } catch (e) {}
  },
  computed: {
    visible: {
        get() {
          return _.get(this.$store.state, 'showLocation', false)
        },
        set(value) {
          this.$store.commit('setLocationStatus', value)
        }
    }
  },
  methods: {
    async performLogin() {

      const res = await this.$CapacitorStorage.get({ key: 'login_mode' });
      let login_mode = _.get(res, 'value')
      
      //trigger login
      if(login_mode == 'auto' || login_mode == 'biometric') {
        setTimeout(() => {
          this.$root.$emit('login_force')
        }, 1000)
      }

    },
    async checkLocation() {
      let device = await this.$CapacitorDevice.getInfo()
      let current_position = null
      let permissions = null
      try {
        current_position = await this.$CapacitorGeolocation.getCurrentPosition({timeout: 1000, maximumAge: 10000*10000})
      } catch(e) {
        alert('getCurrentPosition: ' + e.message);
      }
      console.log('permissions', current_position);
      try {
        permissions = await this.$CapacitorGeolocation.checkPermissions()
        console.log('permissions', permissions);
        //const permissions = await this.$CapacitorGeolocation.checkPermissions()
        if (_.get(permissions, 'location') == 'granted') {
          //now make a request
          this.checkRestriction()

        } else if (_.get(permissions, 'location') == 'denied') {
          this.status = 'denied'
        } else {
          this.status = 'request_permissions'
        }
      } catch(e) {
        alert('checkPermissions: ' + e.message);
      }
    },
    async checkRestriction() {
      this.status = 'locating'

      const response = await require('axios').get('https://sportapi-native.netbet.com/ip_check_new.php',
        { params: {
          time: luxon.DateTime.now().valueOf(),
          country: this.$config.APP_COUNTRY?this.$config.APP_COUNTRY:this.country,
          lang: this.lang,
          environment: process.env.ENVIRONMENT,
        }}
      )
      console.log('checkRestriction', response, _.get(response, 'data.status'))

      if(_.get(response, 'data.status')) {

        //let's set the config
        //this.$config.COUNTRY = _.get(response, 'data.country');
        //this.$config.BOOKMAKER = _.get(response, 'data.config.bookmaker');
        //this.$config.GLOBAL_IFRAME = _.get(response, 'data.config.global_iframe');
        this.$config.OPERATOR_API = _.get(response, 'data.config.api_url', '');
        this.$config.OPERATOR_API_LANG = _.get(response, 'data.config.api_lang', '');
        this.$config.OPERATOR_DOMAIN = _.get(response, 'data.config.domain', '');
        //this.$config.DEFAULT_CURRENCY = _.get(response, 'data.config.default_currency');
        this.$root.$emit('update_config')

        await this.$CapacitorStorage.set({ key: 'location_success_at', value: luxon.DateTime.now().valueOf() })
        this.$root.$emit('splash_hide')
        this.performLogin();
        setTimeout(() => {
          
          try {
            if(this.system == 'app') {this.$CapacitorPush.subscribeToNotifications();}
          } catch (e) {}
          
          this.visible = false //wait for iframe
          if (this.$config.GLOBAL_IFRAME.indexOf("staging") > -1) {
            alert(this.$config.GLOBAL_IFRAME)
          }
        }, 1500)        
      } else {
        this.status = 'error'
      }
    },
    async askPermission() {
      const position = await this.$CapacitorGeolocation.getCurrentPosition()
      console.log('position', position)

      const permissions = await this.$CapacitorGeolocation.requestPermissions()
      console.log('permissions', permissions)
    },
    async allow() {
      try {
        const position = await this.$CapacitorGeolocation.getCurrentPosition()
        console.log('position', position)
      } catch (e) {}

      try {
        const permissions_request = await this.$CapacitorGeolocation.requestPermissions()
        console.log('permissions_request', permissions_request)
      } catch (e) {}

      const permissions = await this.$CapacitorGeolocation.checkPermissions()
      console.log('permissions', permissions)
      if (_.get(permissions, 'location') == 'granted') {
        this.checkRestriction()
      }
      if (_.get(permissions, 'location') == 'denied') {
        this.status = 'denied'
      }
    },
    async retryLocation() {
      if (this.platform == 'web') {
          this.checkRestriction()
          return
      }

      const permissions = await this.$CapacitorGeolocation.checkPermissions()
      console.log('permissions', permissions)
      if (_.get(permissions, 'location') == 'denied') {
        const { value } = await this.$CapacitorDialog.confirm({
          title: 'Please enable location services before retrying',
          message: null
        })
        console.log('Confirmed:', value)
        if (value) {
          this.openSettings()
        }
      } else {
        this.checkLocation()
        this.allow()
      }
    },
    async openWebsite() {
      await this.$CapacitorAppLauncher.openUrl({ url: 'https://netbet.com' })
    },
    async openSettings() {
      if (this.platform == 'ios') {
        this.$CapacitorNativeSettings.openIOS({
          option: 'app'
        })
      }
      if (this.platform == 'android') {
        this.$CapacitorNativeSettings.openAndroid({
          option: 'location'
        })
      }
    }
  }
}
